
    .responsive3839243538__root .ActionsListItem1081675962__root {
        --ActionsListItem1081675962-height-item: 56px;
        --ActionsListItem1081675962-color-item-highlight: #dce9ff;
        --ActionsListItem1081675962-margin-icon: 8px;
        --ActionsListItem1081675962-border-radius-icon: 4px;
    }

/* st-namespace-reference="../../../../src/skins/responsive/ActionsListItem.st.css" */